<template>
  <custom-dialog
    width="1000px"
    :title="model.title"
    :visible="visible"
    v-on="$listeners"
    class="import-sim-network-flow-dialog"
  >
    <div class="dialog-body">
      <div class="btn-group">
        <div class="btn-add ub-f1">
          <input
            type="file"
            ref="file"
            id="file"
            multiple="multiple"
            @change="handleFile"
          />
          <div style="display: inline-block">
            <i class="icon icon-add"></i>
            <span>
              {{ $t('dms_import_sim_network_flow_dialog.xzmbgswj') }}
            </span>
          </div>
        </div>
        <div
          class="btn-tpl"
          @click="onDownloadTpl"
        >
          <div style="display: inline-block">
            <i class="icon icon-daochu"></i>
            <span>{{ $t('dms_import_sim_network_flow_dialog.xia_zai') }} {{ $t('dms_import_sim_network_flow_dialog.pldrSIMll') }}</span>
          </div>
        </div>
      </div>
      <div class="tip-box">
        <div
          v-if="tip"
          class="result"
          v-html="tip"
        ></div>
      </div>
      <div
        class="search"
        style="height: 40px; overflow: hidden"
      >
        <el-form :inline="true">
          <el-form-item>
            <el-button
              @click="onSwitch(true)"
              :type="showOk ? 'primary' : ''"
              :plain="!showOk"
            >{{ $t('dms_import_sim_network_flow_dialog.yan_zheng_tong_guo') }}（{{ okNum }}）</el-button>
          </el-form-item>
          <el-form-item>
            <el-button
              @click="onSwitch(false)"
              :type="!showOk ? 'primary' : ''"
              :plain="showOk"
            >{{ $t('dms_import_sim_network_flow_dialog.yi_chang_shu_ju') }}（{{ failNum }}）</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 验证通过 -->
      <div v-show="showOk">
        <custom-table
          :data="okList"
          tableCode="sim_flow_import_success"
          @filter="filterChange"
          @sort="sortChange"
        ></custom-table>
        <div class="table-page">
          <custom-page
            :total="okNum"
            :page="formSearch.pageNum"
            :size="formSearch.pageSize"
            @change="onPageChange"
          ></custom-page>
        </div>
      </div>
      <!-- 验证失败 -->
      <div v-show="!showOk">
        <custom-table
          :data="failList"
          tableCode="sim_flow_import_error"
          @filter="filterChange"
          @sort="sortChange"
        ></custom-table>
        <div class="table-page">
          <custom-page
            :total="failNum"
            :page="formSearch.pageNum"
            :size="formSearch.pageSize"
            @change="onPageChange"
          ></custom-page>
        </div>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="closeDialog">
          {{ $t('Common.com_cancel') }}
        </el-button>
        <el-button
          v-if="showOk"
          type="primary"
          :disabled="!okNum"
          @click="saveBatchImport"
        >
          {{ $t('dms_import_sim_network_flow_dialog.que_ren') }}
        </el-button>
        <el-button
          v-else
          type="primary"
          :disabled="!failNum"
          @click="onDownloadFail"
        >{{ $t('dms_import_sim_network_flow_dialog.dao_chu_yi_chang') }}</el-button>
      </div>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      batchNum: '',
      failList: [],
      failNum: 0,
      okList: [],
      okNum: 0,
      showOk: true,
      tip: '',
      formSearch: {
        pageNum: 1,
        pageSize: 50,
      }
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    onSwitch(type) {
      this.showOk = type;
      this.onPageChange({ page: 1, size: 16 });
    },
    // 初始化
    init: function () {
      this.$nextTick(() => {
        this.visible = true;
      });

      this.failList = [];
      this.failNum = 0;
      this.okList = [];
      this.okNum = 0;
      this.showOk = true;
      this.tip = '';
      // this.getTableColumn();
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    // 模板下载
    onDownloadTpl: function () {
      this.$exportFlie(apis.simIstDataLimitDownloadTemplate);
    },
    // 文件上传
    handleFile: function (e) {
      this.$postFile(apis.simIstDataLimitImport, e).then((res) => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$refs.file.value = '';
        this.batchNum = res.data;
        // 默认获取成功条数
        this.getBatchOk();
        // 失败条数
        this.getBatchFail();
      });
    },
    // 异常导出
    onDownloadFail: function () {
      this.$exportFlie(`${apis.simIstDataLimitExportFail}/${this.batchNum}`);
    },

    // 获取成功列表分页
    getBatchOk: function () {
      this.$getJSON(`${apis.simIstDataLimitImportSuccessPage}/${this.batchNum}`, this.formSearch).then((res) => {
        const data = res.data || {};
        this.okList = data.list || [];
        this.okNum = data.total || 0;
      });
    },
    // 获取异常列表分页
    getBatchFail: function () {
      this.$getJSON(`${apis.simIstDataLimitImportFailPage}/${this.batchNum}`, this.formSearch).then((res) => {
        const data = res.data || {};
        this.failList = data.list || [];
        this.failNum = data.total || 0;
      });
    },
    // 保存入库
    saveBatchImport: function () {
      this.$postJSON(`${apis.simIstDataLimitImportSave}/${this.batchNum}`).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('success');
        this.closeDialog();
      });
    },
    getTableList() {
      if (this.showOk) {
        this.getBatchOk();
      } else {
        this.getBatchFail();
      }
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss">
.import-sim-network-flow-dialog {
  .btn-group {
    margin-bottom: 20px;
    overflow: hidden;

    .btn-add {
      height: 44px;
      line-height: 44px;
      text-align: center;
      background: rgba(245, 245, 245, 1);
      border: 1px dashed rgba(228, 228, 228, 1);
      color: #333333;
      font-size: 12px;
      position: relative;
      float: left;
      width: 750px;

      input {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
        display: block;
        width: 100%;
        height: 100%;
        opacity: 0;
        cursor: pointer;
      }
      .icon {
        color: #00afff;
        font-size: 12px;
        margin-right: 4px;
      }
    }
    .btn-tpl {
      float: right;
      width: 192px;
      height: 44px;
      line-height: 44px;
      text-align: center;
      border: 1px solid rgba(228, 228, 228, 1);
      margin-left: 10px;
      color: #333333;
      font-size: 12px;
      cursor: pointer;
      .icon {
        color: #00afff;
        font-size: 12px;
        margin-right: 4px;
      }
    }

    // .tip-tpl {
    //   color: #0d9ae0;
    //   cursor: pointer;
    // }
  }
  .tip-box {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    .result {
      // padding: 6px 10px 0;
      color: #262626;
      font-size: 12px;
      // height: 40px;
      flex: 1;
      align-self: center;
      .ok {
        color: blue;
      }
      .fail {
        color: red;
      }
    }
  }

  .el-dialog__body .dialog-footer {
    padding-right: 0;
    padding-bottom: 0;
  }
}
</style>
